// OverviewPanel.jsx
export default function OverviewPanel({ user, onNavigate }) {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl p-4 lg:p-6 shadow-sm border border-outline-variant/10">
        <h2 className="text-xl font-black">Welcome, {user?.name} 🔪</h2>
        <p className="text-secondary text-sm mt-1">Butcher Dashboard — Overview coming soon.</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
          {[
            { label: 'Browse Animals', icon: 'search',       key: 'browse',   color: 'bg-blue-50 text-blue-600'   },
            { label: 'Bulk Orders',    icon: 'inventory_2',  key: 'bulk',     color: 'bg-amber-50 text-amber-600' },
            { label: 'My Shop',        icon: 'storefront',   key: 'shop',     color: 'bg-emerald-50 text-emerald-600' },
            { label: 'Payments',       icon: 'payments',     key: 'payments', color: 'bg-purple-50 text-purple-600'  },
          ].map(item => (
            <button key={item.key} onClick={() => onNavigate(item.key)}
              className={`${item.color} rounded-2xl p-3 lg:p-5 flex flex-col items-center gap-2
                          hover:shadow-md transition-all`}>
              <span className="material-symbols-outlined text-[32px]">{item.icon}</span>
              <span className="font-bold text-sm">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}